import React from 'react';
import {
    Calendar,
    Users,
    Tag,
    ExternalLink,
    Clock,
    CheckCircle,
    AlertCircle,
    Folder,
    Activity ,Eye , Trash2
} from 'lucide-react';

const ProjectGrid = ({
                         projects,
                         isLoading,
                         searchTerm,
                         filterTag,
                         onRefresh,
                         onDeleteProject, // Add this
                         currentUser,     // Add this
                         navigate
                     }) => {
    const getProjectStatusColor = (project) => {
        if (!project.isActive) return 'gray';
        const now = new Date();
        const endDate = new Date(project.endDate);
        const daysUntilEnd = Math.ceil((endDate - now) / (1000 * 60 * 60 * 24));

        if (daysUntilEnd < 0) return 'red';
        if (daysUntilEnd < 7) return 'orange';
        return 'green';
    };

    const getStatusText = (project) => {
        if (!project.isActive) return 'Inactive';
        const now = new Date();
        const endDate = new Date(project.endDate);
        const daysUntilEnd = Math.ceil((endDate - now) / (1000 * 60 * 60 * 24));

        if (daysUntilEnd < 0) return 'Overdue';
        if (daysUntilEnd < 7) return `${daysUntilEnd} days left`;
        return 'Active';
    };

    const handleProjectClick = (projectId) => {
        console.log('Navigating to project:', projectId);
        // Use the correct route that matches your App.js
        navigate(`/project/${projectId}`);
    };

    const filteredProjects = projects.filter(project => {
        const matchesSearch = !searchTerm ||
            project.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            project.description.toLowerCase().includes(searchTerm.toLowerCase());

        const matchesTag = !filterTag ||
            (project.tags && project.tags.includes(filterTag));

        return matchesSearch && matchesTag;
    });

    const canDeleteProject = (project, currentUser) => {
        const isOwner = project.owner === currentUser._id || project.owner?._id === currentUser._id;
        const isAdmin = currentUser.role === 'admin' || currentUser.role === 'super_admin';
        return isOwner || isAdmin;
    };





    if (isLoading) {
        return (
            <div className="projects-section">
                <div className="projects-grid">
                    {[...Array(6)].map((_, index) => (
                        <div key={index} className="project-card skeleton">
                            <div className="skeleton-header"></div>
                            <div className="skeleton-content">
                                <div className="skeleton-line"></div>
                                <div className="skeleton-line short"></div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    if (filteredProjects.length === 0) {
        return (
            <div className="projects-section">
                <div className="empty-state">
                    <div className="empty-icon">
                        <Folder style={{ width: '48px', height: '48px', color: '#9CA3AF' }} />
                    </div>
                    <h3>No Projects Found</h3>
                    <p>
                        {searchTerm || filterTag
                            ? "No projects match your current filters."
                            : "You haven't joined any projects yet. Create a new project or join an existing one with a project code."
                        }
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="projects-section">
            <div className="projects-grid">
                {filteredProjects.map((project) => (
                    <div
                        key={project._id}
                        className="project-card"
                        onClick={() => handleProjectClick(project._id)}
                        style={{ cursor: 'pointer' }}
                    >
                        <div className="project-header">
                            <div className="project-title-section">
                                <h3 className="project-name">{project.name}</h3>
                                <div className={`project-status ${getProjectStatusColor(project)}`}>
                                    {getProjectStatusColor(project) === 'green' && <CheckCircle style={{ width: '12px', height: '12px' }} />}
                                    {getProjectStatusColor(project) === 'orange' && <Clock style={{ width: '12px', height: '12px' }} />}
                                    {getProjectStatusColor(project) === 'red' && <AlertCircle style={{ width: '12px', height: '12px' }} />}
                                    {getProjectStatusColor(project) === 'gray' && <Activity style={{ width: '12px', height: '12px' }} />}
                                    <span>{getStatusText(project)}</span>
                                </div>
                            </div>
                            <div className="project-code">
                                <span className="code-label">Code:</span>
                                <span className="code-value">{project.code}</span>
                            </div>
                        </div>

                        <div className="project-description">
                            <p>{project.description}</p>
                        </div>

                        <div className="project-details">
                            <div className="project-dates">
                                <div className="date-item">
                                    <Calendar style={{ width: '14px', height: '14px' }} />
                                    <span>Start: {new Date(project.startDate).toLocaleDateString()}</span>
                                </div>
                                <div className="date-item">
                                    <Calendar style={{ width: '14px', height: '14px' }} />
                                    <span>End: {new Date(project.endDate).toLocaleDateString()}</span>
                                </div>
                            </div>

                            {project.tags && project.tags.length > 0 && (
                                <div className="project-tags">
                                    {project.tags.slice(0, 3).map((tag, index) => (
                                        <span key={index} className="project-tag">
                                            <Tag style={{ width: '12px', height: '12px' }} />
                                            {tag}
                                        </span>
                                    ))}
                                    {project.tags.length > 3 && (
                                        <span className="project-tag more">
                                            +{project.tags.length - 3} more
                                        </span>
                                    )}
                                </div>
                            )}

                            <div className="project-stats">
                                <div className="stat-item">
                                    <Users style={{ width: '14px', height: '14px' }} />
                                    <span>{project.members?.length || 0} members</span>
                                </div>
                                <div className="stat-item">
                                    <CheckCircle style={{ width: '14px', height: '14px' }} />
                                    <span>{project.taskCount || 0} tasks</span>
                                </div>
                            </div>
                        </div>

                        <div className="project-footer">
                            <div className="project-members">
                                {project.members?.slice(0, 3).map((member, index) => (
                                    <div key={index} className="member-avatar" title={member.name}>
                                        {member.name ? member.name.charAt(0).toUpperCase() : member.email?.charAt(0).toUpperCase()}
                                    </div>
                                ))}
                                {project.members?.length > 3 && (
                                    <div className="member-avatar more">
                                        +{project.members.length - 3}
                                    </div>
                                )}
                            </div>

                            <div className="project-actions">
                                {/* Your existing action buttons */}
                                <button className="project-action-btn view">
                                    <Eye style={{ width: '16px', height: '16px' }} />
                                </button>

                                {/* ADD THE DELETE BUTTON HERE */}
                                {canDeleteProject(project, currentUser) && (
                                    <button
                                        className="project-action-btn delete"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onDeleteProject(project._id, project.name);
                                        }}
                                        title={
                                            project.owner === currentUser._id || project.owner?._id === currentUser._id
                                                ? "Delete Project (Owner)"
                                                : "Delete Project (Admin Override)"
                                        }
                                    >
                                        <Trash2 style={{ width: '16px', height: '16px' }} />
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                ))}


            </div>
        </div>
    );
};

export default ProjectGrid;